import type {SketchSlotObject} from '../sketch/SketchSlotObject';
import {hasRuntimeFlag} from './hasRuntimeFlag';

/**
 * 判断对象是否为草图槽口对象。
 * @param value 待判断对象。
 * @returns 当对象满足草图槽口协议时返回 true。
 */
export function isSketchSlotObject(value: unknown): value is SketchSlotObject {
	// 通过统一标记字段判断槽口对象身份。
	return hasRuntimeFlag(value, 'isSketchSlotObject');
}
